// @ts-nocheck
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { CatalogPageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

const catalogPagesUrl = "/api/v1/catalogpages";
const productsUrl = "/api/v2/products";

// storeGetProductByPath is based on getProductByPath located in modules\client-framework\src\Services\ProductServiceV2.ts with the addition of additionalQueryStringParameters as parameter
export async function storeGetProductByPath(parameter: GetProductByPathApiV2Parameter) {
    const result = await get<CatalogPageModel>(`${catalogPagesUrl}`, { path: parameter.path } as ApiParameter);
    const productModel = await get<ProductModel>(`${productsUrl}/${result.productId}`, {
        expand: parameter.expand,
        additionalExpands: parameter.additionalExpands,
        includeAttributes: parameter.includeAttributes,
        addToRecentlyViewed: parameter.addToRecentlyViewed,
        additionalQueryStringParameters: parameter.additionalQueryStringParameters,
    } as ApiParameter);

    return productModel;
}
